module.exports = __webpack_public_path__ + "img/EXTERIOR-S-CROSS-2.22b7b3e4.jpg";